import axios from "axios";
import url from "../url.json";

// Har bir API so'roviga joriy token'ni qo'shadi.
// Avval token axios.defaults orqali komponentlar render bo'lganda o'rnatilardi —
// effekt tartibiga qarab birinchi so'rovlar token'siz ketib 401 qaytarardi.
const API_ORIGIN = new URL(url.url).origin;

axios.interceptors.request.use((config) => {
  const target = new URL(config.url, window.location.origin);
  // token faqat o'z API'mizga yuboriladi
  if (target.origin !== API_ORIGIN) return config;

  const token = localStorage.getItem("token");
  config.headers = config.headers || {};
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // eski "Bearer null" kabi qiymat qolib ketmasin
    delete config.headers.Authorization;
  }
  return config;
});
